import React from 'react';
import { BsCheck } from 'react-icons/bs';

export interface ISelectableButtonProps {
    checked: boolean;
    onClick: () => void;
    id: string;
    variant: 'age' | 'child';
    readonly: boolean;
    additionalClasses?: string;
}

export const SelectableButton: React.FunctionComponent<ISelectableButtonProps> = (props) => {
    // default variant is 'age'
    let checkboxPositionClasses = '-top-3 left-1/2 -translate-x-1/2 opacity-90';
    let colorClasses = `${props.checked ? `bg-aap-green-900` : `bg-aap-green-500 hover:bg-aap-green-600`} text-white rounded-sm`;

    if(props.variant === 'child') {
        checkboxPositionClasses = '-top-3 -right-3 border border-aap-gray-400';
        colorClasses = `${props.checked ? `bg-aap-green-500 text-white` : `bg-white text-aap-gray-500 hover:bg-aap-green-300`} rounded-md border border-aap-gray-400`;
    }

    return (
        <button type="button" className={`${props.additionalClasses} ${colorClasses} px-3 py-1 text-sm transition-all duration-300 relative`} onClick={props.onClick} id={props.id} disabled={props.readonly}>
            {(props.checked || props.variant === 'child') ? (
                <div className={`absolute ${checkboxPositionClasses} bg-white w-6 h-6 shadow-md shadow-aap-gray-700 rounded-full text-aap-gray-400`}>
                    {props.checked ? (
                        <BsCheck size={20} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
                    ) : null}
                </div>
            ) : null}
            {props.children}
        </button>
    );
};
